import { css } from '@emotion/react'
import { Icon, Link, Text } from 'bold-ui'
import { blue } from 'bold-ui/lib/styles/colors'
import { ReactComponent as Consulta } from 'images/historico/icone-consulta.svg'
import { ReactComponent as CuidadoCompartilhado } from 'images/historico/icone-cuidado-compartilhado.svg'
import { ReactComponent as PreNatal } from 'images/historico/icone-pre-natal.svg'
import { ReactComponent as AcompanhamentosIcon } from 'images/side-menu/acompanhamentos.svg'
import { ReactComponent as BuscaAtiva } from 'images/side-menu/busca-ativa.svg'
import { ReactComponent as GarantiaAcessoIcon } from 'images/side-menu/garantia-acesso.svg'
import { ReactComponent as UnificacaoDeCadastros } from 'images/side-menu/merge-do-cidadao.svg'
import { ReactComponent as ProfissionaisIcon } from 'images/side-menu/profissionais.svg'
import { ReactComponent as RelatorioGerencialCuidadoCompartilhado } from 'images/side-menu/relatorios.svg'
import { ReactComponent as UnidadeDeSaude } from 'images/side-menu/unidade-de-saude.svg'
import { ReactComponent as VideochamadaIcon } from 'images/side-menu/videochamadas.svg'
import { ReactComponent as AcompanhamentoTerritorioIcon } from 'images/visualizacao-territorial/casa-icone.svg'
import { CSSProperties, Fragment } from 'react'
import { useHistory } from 'react-router'

import { Carousel, CarouselItem } from '../components/Carousel'
import { NewsGif } from '../components/NewsGif'
import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsImg } from '../components/NewsImg'
import { NewsList } from '../components/NewsList'
import { NewsListItem } from '../components/NewsListItem'
import { NewsParagraph } from '../components/NewsParagraph'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalPanelCincoDois() {
  const history = useHistory()

  return (
    <Fragment>
      <NewsHeadingSection title='Atualização da competência do SIGTAP' id='atualizacao-competencia-sigtap-5-2'>
        <NewsParagraph>
          A tabela de procedimentos SIGTAP do sistema foi atualizada para a competência de 02/2024. Sendo assim, foi
          realizada a inclusão e atualização de procedimentos.
        </NewsParagraph>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Acompanhamento do Território'
        icon={<AcompanhamentoTerritorioIcon style={{ ...styles.iconSVG, fill: blue.c60 }} />}
        id='acompanhamento-territorio-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            A versão 5.2 permite visualizar os cadastros sob responsabilidade da sua equipe de forma mais intuitiva,
            facilitando a gestão do seu território adscrito e a formação de núcleos familiares. Basta acessar a aba
            "Território" na seção Acompanhamentos e conferir as novidades.
          </NewsListItem>
          <NewsListItem>
            Nessa tela, você verá imóveis e seus moradores organizados por microáreas e logradouros, assim como os
            respectivos índices e filtros de cadastros completos e atualizados. Outras informações de apoio também
            estarão lá, como data da última visita e possíveis inconsistências de cadastro.
          </NewsListItem>
          <br />
          <NewsGif
            src='/static/novidades/5-2_acompanhamento_territorio.webm'
            pausedSrc='/static/novidades/5-2_acompanhamento_territorio_paused.webp'
            alt='Demonstração de funcionalidade do Acompanhamento do Território.'
          />
          <br />
          <NewsListItem>
            Além disso, é possível corrigir eventuais divergências de cadastro através da edição de logradouro, que cria
            automaticamente atualizações para os imóveis do mesmo, possibilitando a higienização da sua base de
            cadastros.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Busca ativa de vacinação'
        icon={<BuscaAtiva style={styles.iconSVG} />}
        id='busca-ativa-vacinacao-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Inclusão do Grupo-alvo de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Gestantes/puérperas
            </Text>{' '}
            para Vacinas da Covid-19;
          </NewsListItem>
          <NewsListItem>
            Inclusão do Grupo-alvo de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Gestantes
            </Text>{' '}
            para Vacinas do calendário vacinal;
          </NewsListItem>
          <NewsListItem>
            Inclusão do Grupo-alvo de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Idosos
            </Text>{' '}
            para Vacinas do calendário vacinal;
          </NewsListItem>
          <NewsListItem>
            Inclusão do filtro por{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Faixa etária
            </Text>{' '}
            em cada grupo-alvo disponível para Vacinas do calendário vacinal e Vacinas de Covid-19;
          </NewsListItem>
          <NewsListItem>
            Inclusão do filtro por{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Grupo de atendimento
            </Text>{' '}
            para Vacinas da Covid-19;
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_busca_ativa_vacinacao_grupo_alvo_filtros.webm'
            pausedSrc='/static/novidades/5-2_busca_ativa_vacinacao_grupo_alvo_filtros.webp'
            alt='Demonstração da Busca ativa de vacinação com filtros de grupo-alvo, faixa etária e avançados de imunobiológico e dose.'
          />
          <NewsListItem>
            Exportação do relatório da busca ativa no formato{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              PDF
            </Text>{' '}
            para impressão e download das{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Vacinas do calendário vacinal
            </Text>{' '}
            e{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Vacinas da Covid-19
            </Text>
            .
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_busca_ativa_vacinacao_exportacao.webm'
            pausedSrc='/static/novidades/5-2_busca_ativa_vacinacao_exportacao.webp'
            alt='Demonstração de exportação de relatório PDF da Busca ativa de vacinação.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Cuidado Compartilhado'
        icon={<ProfissionaisIcon style={styles.iconSVG} />}
        id='cuidado-compartilhado-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Todas as Equipe de Saúde da Família (ESF) ou Equipe de Saúde Bucal (ESB) que possuírem vinculo através do
            CNES com equipes multidisciplinares (eMulti) ou equipes de Núcleos de Apoio à Saúde da Família (NASF) terão
            acesso na seção do Plano de atendimentos individuais e de atendimentos odontológicos a nova aba de
            Compartilhamento do Cuidado. O objetivo do compartilhamento de cuidado é possibilitar que o profissional da
            APS discuta o caso clínico do cidadão com um profissional da equipe eMulti ou NASF.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_tela_cuidado_compartilhado.webp'
            alt='Imagem do Cuidado Compartilhado no PEC'
          />
          <NewsListItem>
            Contextualização: O profissional solicitante é quem iniciou o cuidado compartilhado e o profissional
            executante é o profissional de referência que foi indicado para discutir o caso.
          </NewsListItem>
          <NewsListItem>
            O PEC conta com alguns módulos novos para que o profissional solicitante e o profissional executante
            consigam conversar sobre o caso clínico do cidadão. Através do menu lateral, dentro da opção "Gestão de
            filas" existe a opção "Cuidados Compartilhados". Existem duas listagens no módulo de "Cuidados
            Compartilhados":
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-2_gestao_filas_cuidados.webp'
              alt='Imagem do módulo de Gestão de Filas'
            />
            <CarouselItem
              image='/static/novidades/5-2_cuidados_solicitados.webp'
              alt='Imagem dos Cuidados Compartilhados - Solicitados por mim'
            />
            <CarouselItem
              image='/static/novidades/5-2_cuidados_compartilhados.webp'
              alt='Imagem dos Cuidados Compartilhados - Compartilhados comigo'
            />
          </Carousel>
          <NewsListItem>
            "Solicitados por mim" que exibe todos os cuidados solicitados pelo usuário, além dos cuidados solicitados
            pela equipe do usuário.
          </NewsListItem>
          <NewsListItem>
            "Compartilhados comigo" que exibe todos os cuidados compartilhados com o usuário e com a equipe do usuário.
          </NewsListItem>
          <NewsListItem>
            As colunas das tabelas são iguais em ambas as listagens, sendo que todas as linhas possuem um status
            ("Respondido" e "Aguardando") e duas ações possíveis ("Visualizar discussão" e "Discutir caso"). As
            seguintes regras serão aplicadas:
            <NewsList>
              <NewsListItem>
                Na aba "Solicitados por mim" o usuário só poderá clicar em "Discutir caso" caso tenha solicitado aquele
                compartilhamento e caso o status seja "Respondido";
              </NewsListItem>
              <NewsListItem>
                Na aba "Compartilhados comigo" o usuário só poderá clicar em "Discutir caso" caso aquele
                compartilhamento tenha sido compartilhado com ele e caso o status seja "Aguardando";
              </NewsListItem>
              <NewsListItem>
                Sempre que o status for "Aguardando" o sistema exibirá um contador de horas que exibirá há quantas horas
                aquela discussão está aguardando resposta;
              </NewsListItem>
              <NewsListItem>
                O botão "Visualizar discussão" poderá ser acessado por todos os profissionais de nível superior da
                equipe do profissional solicitante ou do profissional executante.
              </NewsListItem>
            </NewsList>
          </NewsListItem>
          <NewsListItem>
            A listagem possui os seguintes filtros para facilitar na organização e busca da lista de Cuidados
            compartilhados:
            <NewsList>
              <NewsListItem>Filtro para buscar o cidadão pelo nome, CPF ou CNS;</NewsListItem>
              <NewsListItem>
                Botão para "Ver somente as minhas solicitações" na aba "Solicitados por mim" e "Ver somente cuidados
                compartilhados comigo" na aba "Compartilhados comigo";
              </NewsListItem>
              <NewsListItem>
                Combo de filtros que permite indicar qual o status, período e profissionais que deverão ser exibidos na
                listagem;
              </NewsListItem>
              <NewsListItem>Alterar a ordenação da lista por classificação de prioridade ou status.</NewsListItem>
            </NewsList>
          </NewsListItem>
          <NewsListItem>
            Ao acessar o módulo de "Discutir caso" o sistema exibirá três abas: "Folha de rosto", "Histórico" e
            "Discussão do caso". As duas primeiras abas são idênticas às abas de um atendimento. A aba de "Discussão de
            caso" conta com:
          </NewsListItem>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-2_discussao_solicitante.webp'
              alt='Imagem do registro da discussão de caso do Cuidado Compartilhado feita pelo Solicitante'
            />
            <CarouselItem
              image='/static/novidades/5-2_discussao_executante.webp'
              alt='Imagem do registro da discussão de caso do Cuidado Compartilhado feita pelo Executante'
            />
          </Carousel>
          <NewsList>
            <NewsListItem>
              Um resumo com todas as informações inseridas no momento de criação do cuidado compartilhado;
            </NewsListItem>
            <NewsListItem>Um histórico com todas as respostas para aquela discussão;</NewsListItem>
            <NewsListItem>Uma seção de condutas a serem adotadas:</NewsListItem>
            <NewsList>
              <NewsListItem>
                Conduta "Devolutiva de discussão do caso clínico" para o profissional executante devem existir quatro
                tipos de devolutiva "Pedido de esclarecimento", "Teleconsultoria" e "Recondução de cuidado" sendo
                obrigatório inserir observações sobre a devolutiva;
              </NewsListItem>
              <NewsListItem>
                Para o profissional solicitante a conduta "Devolutiva de discussão do caso clínico" possui um formato
                diferente, sendo possível inserir uma nova observação sobre a discussão;
              </NewsListItem>
              <NewsListItem>
                Conduta "Agendar consulta" possibilita o agendamento de consultas com cidadão;
              </NewsListItem>
              <NewsListItem>
                Conduta "Trocar profissional de referência" possibilita trocar o profissional executante da discussão.
                Após a troca somente o novo executante poderá participar da discussão.
              </NewsListItem>
              <NewsListItem>
                A conduta "Sugerir agendamento para grupos" tem o propósito de permitir ao profissional executante de
                sugerir a participação do cidadão em atividades coletivas.
              </NewsListItem>
              <NewsListItem>
                Conduta "Reclassificação de prioridade", confere ao profissional alterar a classificação de prioridade
                do cuidado compartilhado.
              </NewsListItem>
            </NewsList>
          </NewsList>
          <NewsListItem>
            A lógica é sempre de pergunta e resposta, portanto o solicitante sempre envia uma dúvida que será respondida
            pelo executante. Esse ciclo poderá ser repetido até todas as dúvidas serem sanadas. As únicas exceções são
            quando:
          </NewsListItem>
          <NewsList>
            <NewsListItem>
              Profissional solicitante faz um agendamento, pois não é gerada uma nova pergunta para o executante
              responder, por consequência o status da discussão continua "Respondido".
            </NewsListItem>
            <NewsListItem>
              Quando o profissional solicitante ou executante optam por reclassificar a prioridade do cuidado
              compartilhado, a conduta "Reclassificação de prioridade" requer sempre uma segunda conduta adicional para
              promover a evolução da discussão e alterar seu status.
            </NewsListItem>
          </NewsList>
          <NewsListItem>Acesso ao Cuidado Compartilhado:</NewsListItem>
          <NewsList>
            <NewsListItem>
              Para acessar o módulo do Cuidado Compartilhado, é necessário que o perfil do profissional tenha o recurso
              habilitado.
            </NewsListItem>
            <NewsListItem>
              O recurso vem ativado por padrão para os seguintes perfis: Coordenador da UBS, Coordenador do CEO, Outros
              profissionais de nível superior NASF, Cirurgião dentista, Cirurgião dentista CEO, Enfermeiro,
              Farmacêutico, Médico e Outro prof. nível superior.
            </NewsListItem>
            <NewsListItem>
              Instalações que utilizam perfis customizados, pode ser necessário habilitar manualmente o acesso ao
              Cuidado Compartilhado.
            </NewsListItem>
          </NewsList>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='e-SUS APS Ampliado'
        icon={<UnidadeDeSaude style={styles.iconSVG} />}
        id='esusAmpliado-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            O e-SUS APS Ampliado passará a reconhecer alguns novos estabelecimentos no sistema.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Facilidades no agendamento de consultas de pré-natal'
        icon={<PreNatal style={styles.iconSVG} />}
        id='agendamento-pre-natal-5-2'
      >
        <NewsSectionContent>
          <NewsParagraph>
            Com a nova funcionalidade de agendamentos, durante um atendimento de pré-natal, será possível realizar o{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              agendamento da próxima consulta para acompanhamento de pré-natal e a consulta odontológica de pré-natal
            </Text>
            . O PEC irá{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              sugerir a data e lotação de profissional
            </Text>
            , sendo que a pessoa responsável pelo atendimento tem liberdade para alterar essas informações conforme
            disponibilidade das partes envolvidas.
          </NewsParagraph>
          <NewsListItem>
            Para o acompanhamento de pré-natal, a data da próxima consulta é sugerida conforme a idade gestacional,
            respeitando as cadências estipuladas na caderneta da gestante, enquanto a lotação de profissional alterna
            entre profissionais com CBO de médico e enfermeiro.
          </NewsListItem>
          <NewsListItem>
            Para as consultas odontológicas, é sugerida uma consulta a cada trimestre da gestação, enquanto a lotação de
            profissional sugerida será de profissional com CBO de dentista.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_agendamento_pre_natal.webm'
            pausedSrc='/static/novidades/5-2_agendamento_pre_natal_paused.webp'
            alt='Demonstração de funcionalidade de agendamento de acompanhamento de pré-natal.'
          />
          <NewsListItem>
            Ainda durante os atendimentos de pré-natal, serão apresentadas as{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              sugestões de quais serão todas as datas
            </Text>{' '}
            que deverão ocorrer os{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              próximos acompanhamentos de pré-natal
            </Text>
            , bem como um{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              atendimento odontológico
            </Text>{' '}
            a cada trimestre da gestação.
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_agendamento_pre_natal_sugestoes.webp'
            alt='Imagem exibindo as sugestões de datas para os próximos acompanhamentos de pré-natal e atendimentos odontológicos'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Gerenciamento de cookies' id='gerenciamento-de-cookies-5-2'>
        <NewsSectionContent>
          <NewsParagraph>
            A partir desta atualização, é possível gerenciar os cookies recolhidos pelo PEC. Os cookies são utilizados
            para melhorar a experiência no sistema e permitir serviços personalizados. Agora, além de estar ciente dos
            cookies recolhidos, você pode escolher quais quer autorizar clicando em "Configurar cookies". Para saber
            mais, acesse{' '}
            <Link onClick={() => history.push('/termosUso')}>Termos de uso e Políticas de privacidade</Link>.
          </NewsParagraph>
          <NewsImg
            src='/static/novidades/5-2_conf_cookies_banner.webp'
            alt='Tela de login do PEC com demosntração de exibição do banner de cookies na parte inferior'
          />
          <NewsImg
            src='/static/novidades/5-2_conf_cookies_modal.webp'
            alt='Modal de configurações avançadas de cookies no PEC'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Garantia do acesso.'
        icon={<GarantiaAcessoIcon style={styles.iconSVG} />}
        id='garantia-acesso-5-2'
      >
        <NewsSectionContent>
          <NewsParagraph>
            O PEC passa a contar com o módulo de Garantia do acesso, cujo objetivo é permitir que os profissionais criem
            uma lista para gerir a demanda reprimida dos cidadãos nos estabelecimentos de saúde. Através do módulo,
            deve-se poder visualizar os contatos e demandas dos cidadãos que buscaram atendimento e não conseguiram
            acesso imediato ao serviço, podendo então direcioná-los para um possível agendamento futuro.
          </NewsParagraph>
          <NewsParagraph>
            Dentre as principais funcionalidades e implementações realizadas no módulo, temos:
          </NewsParagraph>
          <NewsListItem>
            Agendamento de consulta para o cidadão de forma direta através do seu registro na Garantia do acesso;
          </NewsListItem>
          <NewsListItem>
            Filtragem da lista através dos campos de Cidadão, Equipe, Tipo de atendimento ou de serviço e Período de
            registro;
          </NewsListItem>
          <NewsListItem>Coluna de Origem na tabela, indicando o módulo de origem do registro na listagem;</NewsListItem>
          <NewsSectionContent>
            <NewsParagraph>
              A partir da versão 5.2.28, com o objetivo de facilitar a gestão e visualização da listagem do módulo de
              Garantia do acesso, foram implementadas as seguintes atualizações:
            </NewsParagraph>
            <NewsListItem>Recebimento de registros com origem do módulo de Cuidado compartilhado;</NewsListItem>
            <NewsListItem>Filtragem da lista de registros através dos campos de Origem e Profissional;</NewsListItem>
            <NewsListItem>Ordenação da lista através da Classificação por prioridade.</NewsListItem>
          </NewsSectionContent>

          <br />
          <NewsImg
            src='/static/novidades/5-2_tela_garantia_acesso_piloto.webp'
            alt='Imagem da tela do módulo de garantia do acesso.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Histórico do Cuidado Compartilhado'
        icon={<CuidadoCompartilhado style={styles.iconSVG} />}
        id='historico-cuidado-compartilhado-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Durante um atendimento, independente do tipo (consulta, pré-natal, puericultura, etc.), quando for gerado um
            compartilhamento de cuidado, será apresentado um novo bloco dentro do histórico desse atendimento.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_historico_consulta_com_compartilhamento_de_cuidado.webm'
            pausedSrc='/static/novidades/5-2_historico_consulta_com_compartilhamento_de_cuidado_paused.webp'
            alt='Demonstração de como acessar o histórico do atendimento que gerou compartilhamento de cuidado'
          />
          <NewsListItem>
            Todos os eventos de evolução do compartilhamento de cuidado irão gerar novos itens dentro do histórico do
            cidadão. A cada interação, seja do profissional solicitante ou do executante, um novo registro será
            apresentado no histórico.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_historico_cuidado_compartilhado.webm'
            pausedSrc='/static/novidades/5-2_historico_cuidado_compartilhado_paused.webp'
            alt='Demonstração de como acessar os registros de cuidado compartilhado no histórico do cidadão'
          />
          <NewsListItem>Será possível imprimir o registro de cuidado compartilhado.</NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_historico_cuidado_compartilhado_impressao.webp'
            alt='Impressão do registro de cuidado compartilhado'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Modelos personalizados para relatórios gerenciais'
        icon={<Icon icon='filterOutline' style={styles.iconBold} />}
        id='modelos-personalizados-relatorios-gerenciais-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Os modelos personalizados permitem aos profissionais criarem seus próprios modelos definindo filtros,
            colunas e linhas que são utilizadas regularmente na busca de informações dos relatórios gerenciais.
          </NewsListItem>
          <NewsListItem>
            Ao cadastrar um novo modelo, o profissional terá pré-definido quais campos serão utilizados nos relatórios.
          </NewsListItem>

          <NewsGif
            src='/static/novidades/5-2_modelo_personalizado_relatorio_gerencial_criacao_de_modelo.webm'
            pausedSrc='/static/novidades/5-2_modelo_personalizado_relatorio_gerencial_criacao_de_modelo_paused.webp'
            alt='Demonstração de funcionalidade da criação de um Modelo Personalizado para os Relatórios Gerenciais.'
          />

          <NewsListItem>
            Durante a busca, ao selecionar um modelo o sistema automaticamente irá buscar os filtros, colunas e linhas
            previamente definidos no modelo, tornando a busca muito mais eficiente para o profissional.
          </NewsListItem>

          <NewsGif
            src='/static/novidades/5-2_modelo_personalizado_relatorio_gerencial_uso_de_modelo.webm'
            pausedSrc='/static/novidades/5-2_modelo_personalizado_relatorio_gerencial_uso_de_modelo_paused.webp'
            alt='Demonstração de funcionalidade do uso de um Modelo Personalizado para os Relatórios Gerenciais.'
          />

          <NewsListItem>
            Ainda assim, será possível para o profissional alterar as informações durante a utilização do relatório.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='Prescrição de medicamentos' id='prescricao-medicamentos-5-2'>
        <NewsSectionContent>
          <NewsParagraph>
            <b>Atualização do campo "dose" na prescrição de medicamentos</b>
          </NewsParagraph>
          <NewsListItem>
            Com objetivo de qualificar os dados do PEC, a informação da dose na prescrição de medicamentos foi dividida
            em dois campos:
          </NewsListItem>
          <NewsList>
            <NewsListItem>
              <b>Quantidade da dose:</b> Quantidade da dose prescrita. Para doses fracionadas, utilize vírgula ou barra.
              Exemplos: "0,5", "1/2", etc.
            </NewsListItem>
            <NewsListItem>
              <b>Unidade de medida:</b> Unidade de medida para consumo do medicamento prescrito. Exemplos: "comprimido",
              "ml", "sachê", etc.
            </NewsListItem>
          </NewsList>
          <NewsGif
            src='/static/novidades/5-2_campos_dose.webm'
            pausedSrc='/static/novidades/5-2_campos_dose_paused.png'
            alt='Demonstração dos novos campos de dose e unidade de medida no modal da prescrição de medicamentos.'
          />
          <NewsListItem>
            Lembre-se de utilizar o campo <b>"Recomendações"</b> para inserir demais informações relevantes na
            utilização do medicamento.
          </NewsListItem>
          <NewsListItem>
            Para <b>replicar prescrição</b> ou <b>replicar medicamento</b>, é necessário atualizar a informação da dose
            nos novos campos. A informação original será exibida no alerta da prescrição.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_replicar_prescricao.webm'
            pausedSrc='/static/novidades/5-2_replicar_prescricao_paused.png'
            alt='Demonstração do comportamento do modal de prescrição de medicamentos ao replicar uma receita solicitando a alteração dos campos de dose'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Prescrição Digital'
        icon={<Consulta style={styles.iconSVG} />}
        id='prescricao-digital-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Ao encaminhar a prescrição de medicamentos para o cidadão, será possível optar por realizar a impressão ou{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              gerar uma prescrição digital
            </Text>{' '}
            através da opção “Prescrição digital”, caso a instalação esteja habilitada para gerar prescrições digitais.
            O documento da prescrição digital será gerado no formato{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              PDF
            </Text>{' '}
            e enviado ao cidadão, que poderá utilizá-lo para retirar medicamentos. Na farmácia, será possível registrar
            que os medicamentos da prescrição foram fornecidos. Para utilizar a funcionalidade é necessário ativar a
            integração com o servidor de Prescrição digital.
          </NewsListItem>
          <NewsListItem>
            A prescrição digital será encaminhada ao cidadão via{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              e-mail.
            </Text>{' '}
            É possível editar o endereço de e-mail do cidadão antes de encaminhar clicando no ícone de edição ao lado do
            campo.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_prescricao_digital_gerar.webm'
            pausedSrc='/static/novidades/5-2_prescricao_digital_gerar_paused.webp'
            alt='Demonstração de funcionalidade da geração da prescrição digital.'
          />
          <NewsListItem>
            Para gerar a prescrição digital, é necessário realizar uma{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              assinatura eletrônica
            </Text>{' '}
            do documento. O PEC irá abrir uma nova janela para o processo de assinatura.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_prescricao_digital_assinar.webm'
            pausedSrc='/static/novidades/5-2_prescricao_digital_assinar_paused.webp'
            alt='Demonstração de funcionalidade de assinatura do documento da prescrição digital.'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Relatório gerencial de cuidado compartilhado'
        icon={<RelatorioGerencialCuidadoCompartilhado style={styles.iconSVG} />}
        id='relatorio-gerencial-cuidado-compartilhado-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            O relatório é baseado nos eventos ocorridos em cada compartilhamento de cuidado, dessa forma é possível
            computar exatamente quantas interações foram realizadas por cada profissional dentro do período. Além disso,
            há a possibilidade de visualizar o volume de eventos que foram respondidos até e acima das 72h.
          </NewsListItem>
          <NewsListItem>
            Para profissionais eMulti que apoiam múltiplas unidades de saúde, em uma única consulta será possível
            visualizar toda sua produção em todas as unidades.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_relatorio_gerencial_cuidado_compartilhado_producao_em_todas_as_unidades.webm'
            pausedSrc='/static/novidades/5-2_relatorio_gerencial_cuidado_compartilhado_producao_em_todas_as_unidades_paused.png'
            alt='Demonstração de uma consulta das produções de todas a unidades de saúde no relatório gerencial de cuidado compartilhado'
          />
          <NewsListItem>
            O relatório permite que seja visualizado o volume de produção da equipe e do próprio profissional.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_relatorio_gerencial_cuidado_compartilhado_producao_equipe_e_profissional.webm'
            pausedSrc='/static/novidades/5-2_relatorio_gerencial_cuidado_compartilhado_producao_equipe_e_profissional_paused.png'
            alt='Demonstração de uma consulta com as produções da equipe e do próprio profissional no relatório gerencial de cuidado compartilhado'
          />
          <NewsListItem>Será possível exportar o relatório gerencial de cuidado compartilhado.</NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_relatorio_gerencial_cuidado-compartilhado_exportacao.webp'
            alt='Exportação do relatório gerencial de cuidado compartilhado'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection title='RNDS - Envio de registros' id='envio-rnds-5-2'>
        <NewsSectionContent>
          <NewsListItem>
            Para as instalações com a RNDS configurada, os seguintes registros serão enviados à Rede Nacional de Dados
            em Saúde (RNDS):
          </NewsListItem>
          <NewsList>
            <NewsListItem>
              <b>Vacinação</b>: Envio ao finalizar o atendimento de vacinação. As transcrições de caderneta também serão
              enviadas, tanto as cadastradas no atendimento de vacinação quanto no atendimento individual.
            </NewsListItem>
            <NewsListItem>
              <b>Atendimentos individuais</b>: Envio ao finalizar o atendimento individual. Atendimentos em que o
              cidadão ficou em observação também serão enviados após sua finalização.
            </NewsListItem>
            <NewsListItem>
              <b>Prescrição de medicamentos</b>: Envio ao finalizar o atendimento em que houve a prescrição de
              medicamentos.
            </NewsListItem>
            <NewsListItem>
              <b>Atestados</b>: Envio ao finalizar o atendimento em que houve a geração de atestado do modelo padrão.
            </NewsListItem>
          </NewsList>
          <NewsListItem>
            Nova página para visualização da quantidade de registros enviados, localizada no módulo de "Gestão
            municipal", aba "RNDS". A página exibe informações de acordo com os tipos de registros enviados.
          </NewsListItem>
          <NewsImg src='/static/novidades/5-2_aba_RNDS.webp' alt='Imagem da aba RNDS do módulo de Gestão Municipal' />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Unificação de cadastros'
        icon={<UnificacaoDeCadastros style={styles.iconSVG} />}
        id='unificacao-de-cadastros-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Com a nova funcionalidade de{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Exportar cadastros duplicados
            </Text>
            , agora é possível exportar relatórios no formato CSV com os prováveis cadastros de cidadãos duplicados.{' '}
          </NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_unificacao_de_cadastros.webp'
            alt='Imagem exibindo o novo botão para exportar cadastros duplicados'
          />
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Videochamadas'
        icon={<VideochamadaIcon style={styles.iconSVG} />}
        id='videochamadas-5-2'
      >
        <NewsSectionContent>
          <NewsParagraph>
            A partir desta atualização, é possível realizar{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              videochamadas
            </Text>{' '}
            diretamente no PEC através do novo módulo{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Videochamadas e-SUS APS
            </Text>{' '}
            que oferece um canal oficial de comunicação aos usuários! A ferramenta conta com a possibilidade de conexão
            entre duas pessoas, compartilhamento de tela, picture-in-picture e chat.
          </NewsParagraph>
          <br />
          <NewsImg
            style={styles.imageVideochamada}
            src='/static/novidades/5-2_tela_videochamada.webp'
            alt='Imagem da tela das Videochamadas no PEC'
          />
          <br />
          <NewsParagraph>
            Para utilizar essa nova funcionalidade, é necessário que o acesso à instalação seja feito utilizando o
            protocolo HTTPS e que o{' '}
            <Text fontSize={0.875} fontWeight='bold'>
              Administrador da Instalação
            </Text>{' '}
            habilite as videochamadas nas configurações de internet:
          </NewsParagraph>
          <br />
          <NewsGif
            src='/static/novidades/5-2_videochamadas_habilitar.webm'
            pausedSrc='/static/novidades/5-2_videochamadas_habilitar_paused.webp'
            alt='Demonstração de como habilitar videochamadas no sistema.'
          />
          <br />
          <NewsParagraph>
            Depois disso, basta que seja criada uma nova chamada no módulo Videochamadas e que seja enviado o link de
            acesso para o convidado, seja ele usuário do PEC ou não.
          </NewsParagraph>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-2_videochamadas_modulo.webp'
              alt='Imagem do módulo de Videochamadas'
            />
            <CarouselItem
              image='/static/novidades/5-2_videochamadas_sala_espera.webp'
              alt='Sala de espera para usuários convidados'
            />
          </Carousel>
        </NewsSectionContent>
      </NewsHeadingSection>

      <NewsHeadingSection
        title='Vínculo entre equipes do PEC'
        icon={<AcompanhamentosIcon style={styles.iconSVG} />}
        id='equipes-vinculadas-5-2'
      >
        <NewsSectionContent>
          <NewsListItem>
            Visando possibilitar que profissionais que atuam em equipes especialistas (por exemplo a ESB) possam
            visualizar dados de cidadãos vinculados a equipes como ESF, EAP, entre outras. Com a nova versão do XML do
            CNES (3.1), será possível importar o vínculo que existe entre as equipes. Após a importação, é possível
            visualizar os vínculos na aba de equipes dentro do cadastro de unidades de saúde.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_equipes_vinculadas_visualizacao.webm'
            pausedSrc='/static/novidades/5-2_equipes_vinculadas_visualizacao_paused.webp'
            alt='Demonstração da visualização de equipes vinculadas'
          />
          <NewsListItem>
            Alguns relatórios do sistema foram adaptados para considerar o vínculo entre as equipes. Dessa forma, quando
            um profissional pertencente a uma equipe vinculada a outra consultar as informações, mesmo que o cidadão não
            seja acompanhado por sua equipe, o relatório será apresentado.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-2_equipes_vinculadas_relatorio.webm'
            pausedSrc='/static/novidades/5-2_equipes_vinculadas_relatorio_paused.webp'
            alt='Demonstração do impacto da vinculação de equipes nos relatórios'
          />
          <NewsList>
            <NewsListItem>Acompanhamento de cidadãos vinculados</NewsListItem>
            <NewsListItem>Acompanhamento de condições de saúde</NewsListItem>
            <NewsListItem>Relatório operacional de crianças menores de 5 anos</NewsListItem>
            <NewsListItem>Relatório operacional de gestante/puérpera</NewsListItem>
            <NewsListItem>Relatório operacional de risco cardiovascular</NewsListItem>
            <NewsListItem>Relatório operacional de cadastro territorial</NewsListItem>
            <NewsListItem>Relatório consolidado de cadastro domiciliar e territorial</NewsListItem>
            <NewsListItem>Relatório consolidado de cadastro individual</NewsListItem>
            <NewsListItem>Relatório consolidado de situação do território</NewsListItem>
            <NewsListItem>Busca ativa de vacinação</NewsListItem>
          </NewsList>
          <NewsListItem>Os relatórios impactados apresentam a mensagem da imagem abaixo em seu cabeçalho:</NewsListItem>
          <NewsImg
            src='/static/novidades/5-2_equipes_vinculadas_relatorio_info.webp'
            alt='Imagem do aviso de vinculação de equipes nos relatórios'
          />
        </NewsSectionContent>
      </NewsHeadingSection>
    </Fragment>
  )
}

const styles = {
  imageVideochamada: css`
    max-width: 812px;
    max-height: 100%;
  `,
  iconBold: css`
    margin-right: 0.25rem;
    width: 32px;
    height: 32px;
  `,
  iconSVG: css`
    margin-right: 0.25rem;
    width: 32px;
    height: 32px;
  ` as CSSProperties,
}
